import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import {
  EmailAliasGetResponse,
  IndirectTaxCorporationDataResponse,
  SettingsGetResponse,
} from './types';

/**
 * Hook to get sales tax corporation data (including email_alias).
 * GET /new-sales-tax/corporations/:corporationId
 */
export function useIndirectTaxCorporationData(corporationId: number) {
  const {
    data,
    mutate,
    error,
  }: {
    data?: IndirectTaxCorporationDataResponse;
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `new-sales-tax/corporations/${corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      ''
    )
  );

  return {
    data,
    mutate,
    error,
  };
}

export function useCorporationSettings({
  corporationId,
}: {
  corporationId: number;
}) {
  const {
    data,
    mutate,
    error,
  }: {
    data?: SettingsGetResponse;
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `new-sales-tax/corporations/${corporationId}/settings`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    mutate,
    error,
  };
}

export function useEmailAliasForEmailForwarding({
  corporationId,
}: {
  corporationId: number;
}) {
  const {
    data,
    mutate,
    error,
  }: {
    data?: EmailAliasGetResponse;
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `new-sales-tax/corporations/${corporationId}/email-alias`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    mutate,
    error,
  };
}
